import {get} from "lodash"

export default (error) => {
  if (!error) {
    return null
  }

  const {graphQLErrors, networkError} = error

  if (graphQLErrors.length > 0) {
    return get(error, "graphQLErrors[0].apiError.response.data.errorCode")
  }

  if (networkError && "errorCode" in networkError) {
    return networkError.errorCode
  }

  return error.message
}
